<template>
    <div>
        <div class="row">
            <!-- ./col -->
            <div v-if="$hasPermission('tempvehicle.application.view')" class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-danger">
                    <div class="inner">
                        <h3>{{ in_routing_applications.length }}</h3>
                        <p>{{ $t('label.enrouting')}}</p>
                    </div>
                    <div class="icon">
                        <fa :icon="fas.faFile" class="nav-icon"/>
                    </div>
                    <router-link :to="{ name: 'SearchApplication', query: { 'status' : 'enrouting' }}" class="small-box-footer">{{ $t('label.more_info') }}<i class="fas fa-arrow-circle-right"></i></router-link>
                </div>
            </div>
            <div v-if="$hasPermission('tempvehicle.application.view')" class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-success">
                    <div class="inner">
                        <h3>{{ entry_today.length }}</h3>

                        <p>{{ $t('label.today_entry')}}</p>
                    </div>
                    <div class="icon">
                        <fa :icon="fas.faCar" class="nav-icon"/>
                    </div>
                    <router-link :to="{ name: 'SearchApplication', query: { 'today' : true, 'registration_type' : 'IM' }}" class="small-box-footer">{{ $t('label.more_info') }}<i class="fas fa-arrow-circle-right"></i></router-link>
                </div>
            </div>

            <!-- ./col -->
            <div v-if="$hasPermission('tempvehicle.vehicle.view')" class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-info">
                    <div class="inner">
                        <h3>{{ exit_today.length }}</h3>

                        <p>{{ $t('label.today_exit')}}</p>
                    </div>
                    <div class="icon">
                        <fa :icon="fas.faCar" class="nav-icon"/>
                    </div>
                    <router-link :to="{ name: 'SearchApplication', query: { 'today' : true, 'registration_type' : 'EX'  }}" class="small-box-footer">{{ $t('label.more_info') }}<i class="fas fa-arrow-circle-right"></i></router-link>
                </div>
            </div>
            <!-- ./col -->
            <div v-if="$hasPermission('tempvehicle.driver.view')" class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-warning-gradient">
                    <div class="inner">
                        <h3>{{ total_declaration }}</h3>

                        <p>{{ $t('label.declarations')}}</p>
                    </div>
                    <div class="icon">
                        <fa :icon="fas.faUsers" class="nav-icon"/>
                    </div>
                    <router-link :to="{ name: 'SearchApplication'}" class="small-box-footer">{{ $t('label.more_info') }}<i class="fas fa-arrow-circle-right"></i></router-link>
                </div>
            </div>
            <!-- ./col -->
        </div>

        <div v-if="$hasPermission('tempvehicle.application.view')" class="card card-primary card-outline">
            <div class="card-header">
                <h3 class="card-title">{{$t('label.entry_vehicles_today')}}</h3>
                <div class="card-tools">
<!--                    <button type="button" class="btn btn-tool" data-widget="collapse"><fa :icon="fas.faMinus"/></button>-->
                </div>
            </div>
            <div class="card-body">
                <div class="table-responsive" v-if="entry_vehicles.length > 0">
                    <table class="table table-bordered mb-0">
                        <thead>
                        <tr>
                            <th nowrap style="width: 1%;"></th>
                            <th nowrap>{{$t('label.customs_registration')}}</th>
                            <th nowrap>{{$t('label.plate_number')}}</th>
                            <th nowrap>{{$t('label.brand')}}</th>
                            <th nowrap>{{$t('label.color')}}</th>
                            <th nowrap>{{$t('label.frame_number')}}</th>
                            <th nowrap>{{$t('label.engine_number')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(vehicle, index) in entry_vehicles" :key="index">
                            <td>{{index + 1}}</td>
                            <td><router-link :to="{ name:'ViewApplication', params:{ uuid: vehicle.uuid }}" :title="$t('label.view')" target="_blank" class="mr-1">{{vehicle.registration_year}} {{vehicle.registration_serial}} {{vehicle.registration_number}}</router-link></td>
                            <td>{{vehicle.plate_number}}</td>
                            <td>{{vehicle.brand}}</td>
                            <td>{{vehicle.color}}</td>
                            <td>{{vehicle.frame_number}}</td>
                            <td>{{vehicle.engine_number}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="callout callout-success mb-0" v-else>
                    <label>{{$t('label.empty_data')}}</label>
                </div>
            </div>
            <div class="card-footer" v-if="entry_vehicles.length > 0">
                <paginate class="mb-0"
                          v-model="import_page"
                          :page-count="import_last_page"
                          :force-page="import_forcepage"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="getEntryVehicles"
                          :container-class="'pagination float-right'"
                          :prev-text="'Prev'"
                          :next-text="'Next'"
                          :page-class="'page-item'"
                          :active-class="'active'"
                          :prev-link-class="'page-link'"
                          :next-link-class="'page-link'"
                          :page-link-class="'page-link'"
                          ref="entry">
                </paginate>
            </div>
        </div>

        <div v-if="$hasPermission('tempvehicle.application.view')" class="card card-primary card-outline">
            <div class="card-header">
                <h3 class="card-title">{{$t('label.exit_vehicles_today')}}</h3>
                <div class="card-tools">
<!--                    <button type="button" class="btn btn-tool" data-widget="collapse"><fa :icon="fas.faMinus"/></button>-->
                </div>
            </div>
            <div class="card-body">
                <div class="table-responsive" v-if="exit_vehicles.length > 0">
                    <table class="table table-bordered mb-0">
                        <thead>
                        <tr>
                            <th nowrap style="width: 1%;"></th>
                            <th nowrap>{{$t('label.customs_registration')}}</th>
                            <th nowrap>{{$t('label.plate_number')}}</th>
                            <th nowrap>{{$t('label.brand')}}</th>
                            <th nowrap>{{$t('label.color')}}</th>
                            <th nowrap>{{$t('label.frame_number')}}</th>
                            <th nowrap>{{$t('label.engine_number')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(vehicle, index) in exit_vehicles" :key="index">
                            <td>{{index + 1}}</td>
                            <td><router-link :to="{ name:'ViewApplication', params:{ uuid: vehicle.uuid }}" :title="$t('label.view')" target="_blank" class="mr-1">{{vehicle.registration_year}} {{vehicle.registration_serial}} {{vehicle.registration_number}}</router-link></td>
                            <td>{{vehicle.plate_number}}</td>
                            <td>{{vehicle.brand}}</td>
                            <td>{{vehicle.color}}</td>
                            <td>{{vehicle.frame_number}}</td>
                            <td>{{vehicle.engine_number}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="callout callout-success mb-0" v-else>
                    <label>{{$t('label.empty_data')}}</label>
                </div>
            </div>
            <div class="card-footer" v-if="exit_vehicles.length > 0">
                <paginate class="mb-0"
                          v-model="export_page"
                          :page-count="export_last_page"
                          :force-page="export_forcepage"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="getExitVehicles"
                          :container-class="'pagination float-right'"
                          :prev-text="'Prev'"
                          :next-text="'Next'"
                          :page-class="'page-item'"
                          :active-class="'active'"
                          :prev-link-class="'page-link'"
                          :next-link-class="'page-link'"
                          :page-link-class="'page-link'"
                          ref="exit">
                </paginate>
            </div>
        </div>

        <div v-if="$hasPermission('tempvehicle.application.view')" class="card card-warning card-outline">
          <div class="card-header">
            <h3 class="card-title">{{$t('label.request_change')}}</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-widget="collapse"><fa :icon="fas.faMinus"/></button>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive" v-if="amendment_applications.data.length > 0">
              <table class="table table-bordered mb-0">
                <thead>
                <tr>
                  <th nowrap style="width: 1%;"></th>
                  <th nowrap>{{$t('label.customs_registration')}}</th>
                  <th nowrap>{{$t('label.register_date')}}</th>
                  <th nowrap>{{$t('label.type')}}</th>
                  <th nowrap>{{$t('label.lodgement_office_name')}}</th>
                  <th nowrap>{{$t('label.lodgement_office_date')}}</th>
                  <th nowrap>{{$t('label.destination_office_name')}}</th>
                  <th nowrap>{{$t('label.destination_office_date')}}</th>
                </tr>
                </thead>
                <tbody  >
                <tr v-for="(app, index) in amendment_applications.data" :key="index">
                  <td>{{index+1}}</td>
                  <td><router-link :to="{ name:'ViewApplication', params:{ uuid: app.uuid }}" :title="$t('label.view')" target="_blank" class="mr-1">{{app.registration_year}} {{app.registration_serial}} {{app.registration_number}}</router-link></td>
                  <td>{{app.registration_date}}</td>
                  <td>{{app.registration_type}}</td>
                  <td>{{app.lodgement_office_code}}</td>
                  <td>{{app.lodgement_office_date}}</td>
                  <td>{{app.destination_office_code}}</td>
                  <td>{{app.destination_office_date}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="callout callout-success mb-0" v-else>
              <label>{{$t('label.empty_data')}}</label>
            </div>
          </div>
          <div class="card-footer" v-if="amendment_applications.data.length > 0">
            <paginate class="mb-0"
                      :page-count="amendment_applications.last_page"
                      :force-page="amendment_applications.current_page"
                      :page-range="3"
                      :margin-pages="2"
                      :click-handler="getAmendmentApplications"
                      :container-class="'pagination float-right'"
                      :prev-text="'Prev'"
                      :next-text="'Next'"
                      :page-class="'page-item'"
                      :prev-link-class="'page-link'"
                      :next-link-class="'page-link'"
                      :page-link-class="'page-link'">
            </paginate>
          </div>
        </div>

        <!-- <div class="card card-danger">
            <div class="card-header">
                <h3 class="card-title">{{$t('label.over_stay_applications')}}</h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-widget="collapse"><fa :icon="fas.faMinus"/></button>
                </div>
            </div>
            <div class="card-body">
                <div class="table-responsive" v-if="over_stay_applications.length > 0">
                    <table class="table table-bordered mb-0">
                        <thead>
                            <tr>
                                <th nowrap style="width: 1%;"></th>
                                <th nowrap>{{$t('label.lodgement_office_name')}}</th>
                                <th nowrap>{{$t('label.type')}}</th>
                                <th nowrap>{{$t('label.register_date')}}</th>
                                <th nowrap>{{$t('label.register_number')}}</th>
                                <th nowrap>{{$t('label.lodgement_office_date')}}</th>
                                <th nowrap>{{$t('label.destination_office_name')}}</th>
                                <th nowrap>{{$t('label.destination_office_date')}}</th>
                                <th nowrap>{{$t('label.company_code')}}</th>
                                <th nowrap style="width: 1%;"></th>
                            </tr>
                        </thead>
                        <tbody  >
                            <tr v-for="(app, index) in over_stay_applications" :key="index" :value="app.code"  style="color: red">
                                <td>{{index+1}}</td>
                                <td>{{app.lodgement_office_code}}</td>
                                <td>{{app.registration_type}}</td>
                                <td>{{app.registration_date}}</td>
                                <td>{{app.registration_year}} {{app.registration_serial}} {{app.registration_number}}</td>
                                <td>{{app.lodgement_office_date}}</td>
                                <td>{{app.destination_office_code}}</td>
                                <td>{{app.destination_office_date}}</td>
                                <td>{{app.company_code}}</td>
                                <td>
                                    <router-link :to="{ name:'ViewApplication', params:{ uuid: app.uuid }}" :title="$t('label.view')" class="mr-1"><fa :icon="fas.faEye"/></router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="callout callout-success mb-0" v-else>
                    <label>{{$t('label.empty_data')}}</label>
                </div>
            </div>
            <div class="card-footer" v-if="over_stay_applications.length > 0">
                <paginate class="mb-0"
                    v-model="over_stay_page"
                    :page-count="over_stay_last_page"
                    :force-page="over_stay_forcepage"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="getOverStayApplications"
                    :container-class="'pagination float-right'"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :page-class="'page-item'"
                    :active-class="'active'"
                    :prev-link-class="'page-link'"
                    :next-link-class="'page-link'"
                    :page-link-class="'page-link'"
                    ref="over_stay">
                </paginate>
            </div>
        </div> -->
    </div>
</template>

<script>
    import {fas} from "@fortawesome/free-solid-svg-icons";
    import LineChart from '@/components/charts/Line';
    import BarChart from '@/components/charts/Bar';

    export default {
        components: {
            LineChart,
            BarChart
        },
        name: "OfficerDashboard",
        data() {
            return {
                chart_data_loaded: false,
                declaration_chart: null,
                vehicle_chart: null,
                chart_line: true,
                total_declaration: 0,
                total_vehicle: 0,
                entry_vehicles: [],
                exit_vehicles: [],

                entry_today: [],
                applications : [],
                over_stay_applications : [],
                in_routing_applications: [],
                exit_today: [],

                import_page: 1,
                import_forcepage: 1,
                import_pageNumber:1,
                import_current_page: 1,
                import_last_page: 0,
                import_order_by:'created_at',
                import_order_type:'asc',
                import_order_type_after_sort:'',

                export_page: 1,
                export_forcepage: 1,
                export_pageNumber:1,
                export_current_page: 1,
                export_last_page: 0,
                export_order_by:'created_at',
                export_order_type:'asc',

                export_order_type_after_sort:'',
                amendment_applications: {
                  current_page: 1,
                  data: [],
                  from: 1,
                  to: 10,
                  last_page: 1,
                  per_page: 10,
                  total: 0
                },
            }
        },
        computed: {
            fas() {
                return fas;
            },
        },
        mounted() {
            this.init();
            // this.$root.$on('languageChanged', () => {
            //     this.chart_data_loaded = false;
            // })
        },
        methods:{
            // switchToLine(){
            //     this.chart_line = true;
            // },
            // switchToBar(){
            //     this.chart_line = false;
            // },
            init(){
                this.getApplicationStatus();
                this.getTotalApplications();
                this.getInRoutingApplications();
                this.getExitVehicles();
                this.getEntryVehicles();
                this.getAmendmentApplications(1);
            },
            getOverStayApplications(pageNumber = null, order_by = null, order_type=null){
                this.$store.state.loading.status = true;
                this.over_stay_pageNumber = pageNumber;
                this.over_stay_forcepage = pageNumber;
                let url = 'dashboard/over-stay-applications?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.over_stay_applications = response.data.data;
                    this.over_stay_last_page = response.data.last_page;
                    this.over_stay_current_page = response.data.current_page;
                    this.over_stay_order_type_after_sort = order_type;
                    this.over_stay_order_by = order_by;
                    this.$store.state.loading.status = false;
                }).catch(error => {
                    console.warn(error)
                    this.$store.state.loading.status = false;
                });
            },
            initDeclarationChart(){
                GDCE_Client.requestApi("GET","dashboard/chart/declaration").then(response => {
                    let entry = [
                        response.data.entry.Jan,
                        response.data.entry.Feb,
                        response.data.entry.Mar,
                        response.data.entry.Apr,
                        response.data.entry.May,
                        response.data.entry.Jun,
                        response.data.entry.Jul,
                        response.data.entry.Aug,
                        response.data.entry.Sep,
                        response.data.entry.Oct,
                        response.data.entry.Nov,
                        response.data.entry.Dec
                    ]
                    let exit = [
                        response.data.exit.Jan,
                        response.data.exit.Feb,
                        response.data.exit.Mar,
                        response.data.exit.Apr,
                        response.data.exit.May,
                        response.data.exit.Jun,
                        response.data.exit.Jul,
                        response.data.exit.Aug,
                        response.data.exit.Sep,
                        response.data.exit.Oct,
                        response.data.exit.Nov,
                        response.data.exit.Dec
                    ]
                    this.declaration_chart = {
                        labels  : Object.values(this.$root.$i18n.t('label.months')),
                        datasets: [
                            {
                                label               : this.$root.$i18n.t('label.entry'),
                                backgroundColor		: 'rgba(230, 51, 51, 0.5)',
                                fillColor           : 'rgba(210, 214, 222, .5)',
                                strokeColor         : 'rgba(210, 214, 222, 1)',
                                pointColor          : 'rgba(210, 214, 222, 1)',
                                pointStrokeColor    : '#c1c7d1',
                                pointHighlightFill  : '#fff',
                                pointHighlightStroke: 'rgba(220,220,220,1)',
                                data                : entry
                            },{
                                label               : this.$root.$i18n.t('label.exit'),
                                backgroundColor		: 'rgba(209, 51, 230, 0.7)',
                                fillColor           : 'rgba(209, 51, 230, 0.7)',
                                strokeColor         : 'rgba(209, 51, 230, 0.7)',
                                pointColor          : '#3b8bba',
                                pointStrokeColor    : 'rgba(60,141,188,1)',
                                pointHighlightFill  : '#fff',
                                pointHighlightStroke: 'rgba(60,141,188,1)',
                                data                : exit
                            }
                        ]
                    }
                    this.chart_data_loaded = true;
                })
            },

            getEntryVehicles(pageNumber = null, order_by = null, order_type=null){
                this.import_pageNumber = pageNumber;
                this.import_forcepage = pageNumber;
                let url = 'dashboard/vehicles/IM?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
                GDCE_Client.requestApi("GET",url).then(response => {
                    this.entry_vehicles = response.data.data;
                    this.import_last_page = response.data.last_page;
                    this.import_current_page = response.data.current_page;
                    this.import_order_type_after_sort = order_type;
                    this.import_order_by = order_by;
                }).catch(error => {
                  console.warn(error)
                });
            },
            getExitVehicles(pageNumber = null, order_by = null, order_type=null){
                this.export_pageNumber = pageNumber;
                this.export_forcepage = pageNumber;
                let url = 'dashboard/vehicles/EX?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
                GDCE_Client.requestApi("GET",url).then(response => {
                    this.exit_vehicles = response.data.data;
                    this.export_last_page = response.data.last_page;
                    this.export_current_page = response.data.current_page;
                    this.export_order_type_after_sort = order_type;
                    this.export_order_by = order_by;
                }).catch(error => {
                  console.warn(error)
                });
            },
            getApplicationStatus1(pageNumber = null, order_by = null, order_type=null){
                this.declaration_pageNumber = pageNumber;
                this.declaration_forcepage = pageNumber;
                let url = 'dashboard/applications?today=true';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.applications = response.data;
                    this.entry_today = response.data.filter(function (item) {
                        return item.registration_type.toUpperCase() === 'IM';
                    });

                    this.exit_today = response.data.filter(function (item) {
                        return item.registration_type.toUpperCase() === 'EX';
                    });
                    this.declaration_last_page = response.data.last_page;
                    this.declaration_current_page = response.data.current_page;
                    this.declaration_order_type_after_sort = order_type;
                    this.declaration_order_by = order_by;
                }).catch(error => {
                    console.log(error);
                });
            },
            getApplicationStatus(pageNumber = null, order_by = null, order_type=null){
              let url = 'dashboard/applications?today=true';
              GDCE_Client.requestApi("GET", url).then(response => {
                this.entry_today = response.data.entry_today;
                this.exit_today = response.data.exit_today;

              }).catch(error => {
                console.warn(error)
              });
            },
            getTotalApplications(){
                let url = 'dashboard/total-declaration';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.total_declaration = response.data;
                }).catch(error => {
                  console.warn(error)
                });
            },
            getInRoutingApplications(){
                let url = 'dashboard/in-routing';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.in_routing_applications = response.data;
                }).catch(error => {
                  console.warn(error)
                });
            },
            getAmendmentApplications(pageNumber){
              this.amendment_applications.current_page = pageNumber;
              let url = 'dashboard/amendment-applications?page=' + pageNumber;
              GDCE_Client.requestApi("GET", url).then(response => {
                this.amendment_applications = response.data;
              }).catch(error => {
                console.warn(error)
              });
            },
        }
    }
</script>

<style scoped>

</style>